import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function HeroBanner() {
  const heroMovies = movies.slice(0, 5);

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <div className="absolute inset-0 flex">
        {heroMovies.map((movie, index) => (
          <div
            key={movie.id}
            className={`absolute inset-0 transition-opacity duration-1000 ${index === 0 ? 'opacity-100' : 'opacity-0'}`}
          >
            <img
              src={movie.bannerImage}
              alt={`${movie.title} - 木瓜影视热播推荐`}
              className="w-full h-full object-cover object-top"
            />
          </div>
        ))}
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/30 to-background-50"></div>

      <div className="relative z-10 h-full flex items-center">
        <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="max-w-xl">
            <div className="flex items-center gap-3 mb-4">
              <span className="px-3 py-1 bg-primary-500/90 text-background-50 text-xs font-semibold rounded-full">
                热播推荐
              </span>
              <span className="text-background-50/80 text-sm">
                {heroMovies[0]?.year} · {heroMovies[0]?.category} · {heroMovies[0]?.episodeCount}集全
              </span>
            </div>

            <h1 className="text-3xl md:text-5xl font-heading text-background-50 mb-3 leading-tight">
              {heroMovies[0]?.title}
            </h1>

            <p className="text-background-200/90 text-sm md:text-base mb-6 line-clamp-2 leading-relaxed">
              {heroMovies[0]?.description}
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to={`/detail/${heroMovies[0]?.id}`}
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即观看
              </Link>
              <Link
                to="/category/all"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50/15 text-background-50 border border-background-50/30 rounded-lg hover:bg-background-50/25 transition-colors cursor-pointer"
              >
                <i className="ri-grid-line"></i>
                浏览全部
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex gap-2">
        {heroMovies.map((_, index) => (
          <button
            key={index}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              index === 0
                ? 'bg-primary-500 w-6'
                : 'bg-background-50/40 hover:bg-background-50/70'
            }`}
            aria-label={`切换到第 ${index + 1} 张`}
          />
        ))}
      </div>
    </section>
  );
}